<template>
  <div class="sidebar-pinned">
    <Navbar />

    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-home" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">{{ auth_user.agency_name }}</h4>
              <small style="opacity: 0.8;">Facility dashboard overview</small>
            </div>
            <div class="ml-auto"><TodayTasks /></div>
          </div>
        </div>
      </div>

      <section class="admin-content" style="margin-top: -32px;">
        <div class="container mt-n3 pb-5">

          <!-- ── Stat Tiles ── -->
          <div class="row mb-4">
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <router-link to="/view-clients-provider" class="text-decoration-none">
                <div class="card border-0 shadow-sm h-100">
                  <div class="card-body py-3 px-3">
                    <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Total Enrollees</p>
                    <h3 class="mb-0 font-weight-bold">{{ dashboarddata.enrollees | numeral("0,0") }}</h3>
                  </div>
                </div>
              </router-link>
            </div>

            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Principal</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.principal | numeral("0,0") }}</h3>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Dependents</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.dependants | numeral("0,0") }}</h3>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <router-link to="/list-records" class="text-decoration-none">
                <div class="card border-0 shadow-sm h-100">
                  <div class="card-body py-3 px-3">
                    <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Encounters</p>
                    <h3 class="mb-0 font-weight-bold">{{ dashboarddata.encounters | numeral("0,0") }}</h3>
                  </div>
                </div>
              </router-link>
            </div>

            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <router-link to="/all-claims" class="text-decoration-none">
                <div class="card border-0 shadow-sm h-100">
                  <div class="card-body py-3 px-3">
                    <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Claims</p>
                    <h3 class="mb-0 font-weight-bold">{{ dashboarddata.claims | numeral("0,0") }}</h3>
                  </div>
                </div>
              </router-link>
            </div>

            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Out-going Referrals</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.outgoing_referrals | numeral("0,0") }}</h3>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <router-link to="/all-referrals" class="text-decoration-none">
                <div class="card border-0 shadow-sm h-100">
                  <div class="card-body py-3 px-3">
                    <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">In-coming Referrals</p>
                    <h3 class="mb-0 font-weight-bold">{{ dashboarddata.incoming_referrals | numeral("0,0") }}</h3>
                  </div>
                </div>
              </router-link>
            </div>

            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Employees</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.employees | numeral("0,0") }}</h3>
                </div>
              </div>
            </div>
          </div>

          <!-- ── Analytics ── -->
          <div class="row">
            <div class="col-12 mb-3">
              <h6 class="font-weight-bold text-dark mb-0"><i class="fe fe-activity text-primary mr-2"></i>Analytics Overview</h6>
            </div>
            <div class="col-md-12 mb-4">
              <div class="card shadow-sm border-0">
                <div class="card-body">
                  <ProviderEncountersbyDate />
                </div>
              </div>
            </div>
          </div>

          <!-- ── Claims Table ── -->
          <div class="card shadow table-card">
            <div class="d-flex align-items-center px-4 pt-4 pb-3">
              <i class="fe fe-alert-circle text-primary mr-2"></i>
              <h6 class="mb-0 font-weight-bold">Claims</h6>
            </div>
            <div class="table-responsive">
              <table class="table align-td-middle mb-0">
                <thead class="table-head">
                  <tr>
                    <th class="table-th px-4">Patient</th>
                    <th class="table-th">Diagnosis</th>
                    <th class="table-th">Seen date</th>
                    <th class="table-th">Status</th>
                    <th class="table-th">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="claim in claims" v-bind:key="claim.id" class="table-row">
                    <td class="px-4 py-3 font-weight-bold" style="font-size: 0.85rem;">
                      {{ claim.patient.firstname }}
                      {{ claim.patient.lastname }}
                    </td>
                    <td class="py-3" style="font-size: 0.85rem;">{{ claim.diagnosis.name }}</td>
                    <td class="py-3" style="font-size: 0.85rem;">{{ claim.seen_date }}</td>
                    <td class="py-3">
                      <span v-if="claim.status == 1" class="status-badge status-badge--approved">approved</span>
                      <span v-if="claim.status == 2" class="status-badge status-badge--draft">draft</span>
                      <span v-if="claim.status != 1 && claim.status != 2" class="status-badge status-badge--pending">pending</span>
                    </td>
                    <td class="py-3">
                      <router-link :to="`/claim/${claim.id}`">
                        <button class="btn btn-outline-secondary btn-sm">
                          <i class="fe fe-eye"></i>
                        </button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="!claims || !claims.length">
                    <td colspan="5" class="text-center py-5 text-muted">
                      <i class="fe fe-alert-circle" style="font-size: 2rem; opacity: 0.3;"></i>
                      <p class="mt-2 mb-0">No claims found</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import TodayTasks from "@/components/TodayTasks.vue";
import ProviderEncountersbyDate from "@/views/providers/ProviderEncountersbyDate.vue";

export default {
  components: { TodayTasks,
    Navbar,
    ProviderEncountersbyDate,
  },
  data() {
    return {
      user: null,
      auth_user: "",
      agencies: "",
      claims: "",
      clients: "",
      employees: "",
      dashboarddata: "",
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/user`)
      .then((response) => {
        this.auth_user = response.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    getData() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/provider-dashboard-data/${this.user.type == 'provider' ? this.user.id : this.user.institutional_id}`)
        .then((response) => {
          this.dashboarddata = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getClients() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/getProviderToUser/${this.user.type == 'provider' ? this.user.id : this.user.institutional_id}`)
        .then((response) => {
          this.clients = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getClaims() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/claminByProvider${this.user.type == 'provider' ? this.user.id : this.user.institutional_id}`)
        .then((response) => {
          this.claims = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  created() {
    this.getData();
    this.getClaims();
    this.getClients();
  },
};
</script>
